import { z } from 'zod';

import { BaseWidgetSchema } from './BaseWidgetSchema';
import { WidgetType } from '../../utils/widgetsUtils';

export const SpacerWidgetStaticSchema = BaseWidgetSchema(WidgetType.Spacer);

export type SpacerWidgetStaticSchemaType = z.infer<typeof SpacerWidgetStaticSchema>;
